import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box, Button, Paper, Stack, TextField, Typography, Grid, MenuItem,
  FormControlLabel, Checkbox, Alert, Divider,
} from "@mui/material";
import Swal from "sweetalert2";
import { obterEdicao, salvarEdicao, linkInscricao } from "../../services/edicaoService";
import { listarFormularios } from "../../services/formularioService";

export default function EdicaoForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formularios, setFormularios] = useState([]);
  const [e, setE] = useState({
    Id: 0, Nome: "", Ano: new Date().getFullYear(), IdFormulario: "", DataInicio: "", DataFim: "", Ativo: true,
    RecursoHabilitado: false, RecursoDataInicio: "", RecursoDataFim: "", RecursoEmail: "",
  });
  const [token, setToken] = useState("");

  useEffect(() => {
    (async () => {
      const { data } = await listarFormularios();
      setFormularios(data.filter((f) => f.Ativo));
    })();
  }, []);

  useEffect(() => {
    if (!id) return;
    (async () => {
      const { data } = await obterEdicao(id);
      setE({
        Id: data.Id, Nome: data.Nome, Ano: data.Ano || "", IdFormulario: data.IdFormulario || "",
        DataInicio: data.DataInicio || "", DataFim: data.DataFim || "", Ativo: data.Ativo,
        RecursoHabilitado: !!data.RecursoHabilitado,
        RecursoDataInicio: data.RecursoDataInicio || "", RecursoDataFim: data.RecursoDataFim || "",
        RecursoEmail: data.RecursoEmail || "",
      });
      setToken(data.TokenPublico);
    })();
  }, [id]);

  const salvar = async () => {
    if (!e.Nome.trim()) return Swal.fire("Atenção", "Informe o nome da edição.", "warning");
    try {
      const dto = {
        ...e,
        Ano: e.Ano ? Number(e.Ano) : null,
        IdFormulario: e.IdFormulario || null,
        DataInicio: e.DataInicio || null,
        DataFim: e.DataFim || null,
        RecursoDataInicio: e.RecursoDataInicio || null,
        RecursoDataFim: e.RecursoDataFim || null,
        RecursoEmail: e.RecursoEmail || null,
      };
      const { data } = await salvarEdicao(dto);
      setToken(data.token);
      await Swal.fire("Sucesso", data.mensagem, "success");
      navigate("/edicoes");
    } catch (err) {
      Swal.fire("Erro", err?.response?.data || err.message, "error");
    }
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" mb={2}>
        <Typography variant="h5">{id ? `Edição #${id}` : "Nova edição"}</Typography>
        <Stack direction="row" spacing={1}>
          <Button onClick={() => navigate("/edicoes")}>Voltar</Button>
          <Button variant="contained" onClick={salvar}>Salvar</Button>
        </Stack>
      </Stack>

      <Paper sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 8 }}>
            <TextField fullWidth label="Nome da edição/edital" value={e.Nome}
              onChange={(ev) => setE({ ...e, Nome: ev.target.value })} />
          </Grid>
          <Grid size={{ xs: 6, sm: 4 }}>
            <TextField fullWidth type="number" label="Ano" value={e.Ano}
              onChange={(ev) => setE({ ...e, Ano: ev.target.value })} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField select fullWidth label="Formulário" value={e.IdFormulario}
              onChange={(ev) => setE({ ...e, IdFormulario: ev.target.value })}>
              {formularios.map((f) => <MenuItem key={f.Id} value={f.Id}>{f.Nome}</MenuItem>)}
            </TextField>
          </Grid>
          <Grid size={{ xs: 6, sm: 3 }}>
            <TextField fullWidth type="date" label="Início inscrição" InputLabelProps={{ shrink: true }}
              value={e.DataInicio} onChange={(ev) => setE({ ...e, DataInicio: ev.target.value })} />
          </Grid>
          <Grid size={{ xs: 6, sm: 3 }}>
            <TextField fullWidth type="date" label="Fim inscrição" InputLabelProps={{ shrink: true }}
              value={e.DataFim} onChange={(ev) => setE({ ...e, DataFim: ev.target.value })} />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <FormControlLabel control={<Checkbox checked={e.Ativo}
              onChange={(ev) => setE({ ...e, Ativo: ev.target.checked })} />} label="Ativa" />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <Typography variant="subtitle2" color="primary" sx={{ mt: 1 }}>Recurso contra o resultado</Typography>
            <Divider sx={{ mt: 0.5 }} />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <FormControlLabel control={<Checkbox checked={e.RecursoHabilitado}
              onChange={(ev) => setE({ ...e, RecursoHabilitado: ev.target.checked })} />}
              label="Habilitar recurso para os candidatos" />
          </Grid>
          <Grid size={{ xs: 6, sm: 3 }}>
            <TextField fullWidth type="date" label="Início do recurso" InputLabelProps={{ shrink: true }}
              disabled={!e.RecursoHabilitado}
              value={e.RecursoDataInicio} onChange={(ev) => setE({ ...e, RecursoDataInicio: ev.target.value })} />
          </Grid>
          <Grid size={{ xs: 6, sm: 3 }}>
            <TextField fullWidth type="date" label="Fim do recurso" InputLabelProps={{ shrink: true }}
              disabled={!e.RecursoHabilitado}
              value={e.RecursoDataFim} onChange={(ev) => setE({ ...e, RecursoDataFim: ev.target.value })} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField fullWidth label="E-mail p/ notificação de recurso" placeholder="setor@colegio.com.br"
              disabled={!e.RecursoHabilitado}
              value={e.RecursoEmail} onChange={(ev) => setE({ ...e, RecursoEmail: ev.target.value })} />
          </Grid>
        </Grid>

        {token && (
          <Alert severity="info" sx={{ mt: 2 }}>
            Link de inscrição: <code style={{ wordBreak: "break-all" }}>{linkInscricao(token)}</code>
          </Alert>
        )}
      </Paper>
    </Box>
  );
}
